export default "/images/64884dbd4d0c32cc6632abed8b2341b5.avif";